import { dataEllipsisCircleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconEllipsisCircleSolid = /*#__PURE__*/createIcon(dataEllipsisCircleSolid)
export default IconEllipsisCircleSolid
